const Loader = () => {
  return <div className="loader-cmp">Loading...</div>;
}

export default Loader;